import Highcharts from 'highcharts';

export const figure75 = {
chart: {
backgroundColor: 'rgba(255, 255, 255, 0.0)',
type: 'column',
height: 700,
spacingTop: 30
},
title: {
text: ''
},
//exporting: {
//menuItemDefinitions: {
	    
		 
  //  },
    //buttons: {
	//    contextButton: {
		//		   menuItems: ['JPG', 'PDF'],
				//   symbol: 'url(../img/download-table.svg)'
			//   }
    //}
//},
credits: {
enabled: false
},
xAxis: {
	       categories: ['أفريقيا جنوب الصحراء', 'شمال أفريقيا وغرب آسيا', 'آسيا الوسطى وجنوب آسيا', 'شرق آسيا وجنوب شرق آسيا', 'أمريكا اللاتينية ومنطقة البحر الكاريبي', 'أستراليا ونيوزيلندا', 'أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)', 'أوروبا وأمريكا الشمالية', 'العالم'],
	       opposite: true,
// tickInterval: 5,

// tickmarkPlacement: 'on',
// tickPositions: [0, 5, 10, 15, 19]
labels: {
				   y: -70,
				   style: {
		  textOverflow: 'none'
	  }
},

},
yAxis: {
title: {
text: 'نسبة الأراضي الجبلية المتدهورة (%)'
}, labels: {
formatter: function () {
		 return this.value + '';
	 }
},
min: 0,
max: 2.5,
tickInterval: 0.5,
},
tooltip: {
// pointFormat: 'Series {series.name} <b>{point.y:.4f}</b>'
headerFormat: "<span style='font-size: 10px'>{point.key}</span><br>",
pointFormat: "<span style='color:{point.color}''>\u25CF</span> {series.name}: <b>%{point.y}</b>",
},
legend: {
	       enabled: false,
       }, 
plotOptions: {
column: {
pointPadding: 0,
borderWidth: 0
},
series: {
marker: {
	       enabled: false,
	       "symbol": 'circle',
// radius: 2
       }
}
},
//colors: ['#77A612', '#66A6B7', '#00122F', 'yellow', 'pink', 'purple', '#77A612', '#66A6B7'],
series: [{
name: 'نيفال',
color: '#a5a5a5',
data: [0, 0.012665102, 0.120954399, 0.411313456, 0.429627059, 0.438216287, 0, 0.067473842, 0.088278877]
}, {
name: 'جبال الألب',
color: '#e6ddcc',
data: [0.064503261, 0.443816069, 0.677632211, 1.40481619, 0.82484455, 2.119877462, 0, 2.293306572, 1.843444754, ]

}, {
name: 'مونتان',
color: '#a9b6a2',
data: [1.105632332, 1.80808042, 2.22487379, 1.197601706, 1.2203671, 1.409795824, 0.614644386, 2.01344104, 1.712033569]

}, {
	name: 'المنطقة الجبلية المتبقية',
	      color: '#6c8b8d',
	      data: [1.431956641, 1.01240158, 1.756253994, 2.168245056, 1.525329351, 1.927782712, 0.734488051, 1.493087923, 1.607040271]

       }


]
}

